import { useState, useEffect, useRef } from "react";
import "./dibalikPanit.scss";
import fotoDibalikPanit from "./fotoDibalikPanit";
import TopInfo from "../../Components/TopInfo/TopInfo";
import Heading from "../../Components/Heading/Heading";
import { useParams, useNavigate } from "react-router-dom";

import bg from "../../Assets/HariHariOMB/BG3.png";
import downloadDrive from "../../Assets/HariHariOMB/downloadDrive.svg";


const DibalikPanit = () => {
  const [day, setDay] = useState(0);
  // MODAL
  const [modal, setModal] = useState(false);
  const Modal = useRef(null);
  const [foto, setFoto] = useState(null);

  function openModal(props) {
    setModal(!modal);
    setFoto(props);
  }

  // HANLDE CLOSE MODAL
  useEffect(() => {
    const handleClickRemoveModal = (event) => {
      if (!modal == false) {
        if (Modal.current) {
          setModal(false);
        }
      }
    };
    document.addEventListener("click", handleClickRemoveModal, true);
    return () => {
      document.removeEventListener("click", handleClickRemoveModal, true);
    };
  }, [modal]);

  const array = [
    {
      title: "Di Balik Kepanitiaan",
      bg: bg,
      subTitle: "Di balik kepanitiaan merupakan apresiasi kepada para panitia yang telah mendedikasikan diri dan mencetak sejarah baru bersama OMB UMN 2023.",
      asset: fotoDibalikPanit,
      linkDrive: "https://drive.google.com/drive/folders/1-fKniJI3E-ppUOdyo1b9T4hMG5qWqDj5?usp=drive_link",
    },
  ];

  return (
    <>
      <div className="hariHariOMB__section" style={{ backgroundImage: `url(${array[day].bg})`, backgroundSize: "100% 100%" }}>
        <TopInfo />
        <Heading nama={array[day].title} job={array[day].subTitle} />
        <div className="hariHariOMB__aksesBox">
          <div>
            <p>Mau lihat semua dokumentasi?</p>
            <div className="aksesDriveDiv">
              <img src={downloadDrive} alt="" />
              <a href={array[day].linkDrive} target="_blank">
                Akses <i>Drive</i>
              </a>
            </div>
          </div>
        </div>
        <div className="hariHariOMB__photoGrid">
          {array[day].asset.map((item, index) => {
            return <img src={item.img} class={`photo${index + 1}`} onClick={() => openModal(item.img)} key={item.id} />;
          })}
        </div>
      </div>
      {modal ? (
        <div ref={Modal} id="comingsoon" className="comingsoon">
          <div className="modal-content">
            <img className="foto" src={foto} alt="" />
          </div>
        </div>
      ) : null}
    </>
  );
};

export { DibalikPanit };
